var map = {
	"./aiSecurity/sc.json": [
		3330,
		51
	],
	"./dataLeakage/sc.json": [
		3331,
		54
	],
	"./ppd/sc.json": [
		3332,
		57
	],
	"./ransomware/sc.json": [
		3333,
		60
	],
	"./socialMedia/sc.json": [
		3334,
		63
	],
	"./whatsApp/sc.json": [
		3335,
		66
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1125;
module.exports = webpackAsyncContext;